import { render, staticRenderFns } from "./myorder.vue?vue&type=template&id=00a55616&scoped=true&"
import script from "./myorder.vue?vue&type=script&lang=js&"
export * from "./myorder.vue?vue&type=script&lang=js&"
import style0 from "./myorder.vue?vue&type=style&index=0&id=00a55616&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a55616",
  null
  
)

export default component.exports